<template>
  <button
    @click="handleClickFollowBtn"
    class="term-follow-chip ui-font"
    :class="classes"
  >
    <slot name="term-name"></slot>
  </button>
</template>

<script>
import API from "@/api";
import store from "@/store";
import Util from "@/lib/Util";
import { computed, ref } from "vue";

export default {
  name: "TermFollowChip",
  props: {
    term: Object,
  },
  setup(props) {
    const followFlag = ref(props.term.is_following);

    const isProcessing = ref(false);

    const classes = computed(() => {
      return {
        "term-follow-chip-active": followFlag.value,
        "term-follow-chip-processing": isProcessing.value,
      };
    });

    const handleClickFollowBtn = () => {
      if (!store.state.localSettings) {
        Util.closeAllModals(); // CLOSE ALL MODALS
        store.commit("login/showModal", true); // OPEN LOGIN MODAL
        return;
      }

      Util.debounceEvent(function () {
        recordFollowBtnAction();
      }, 200);
    };

    const recordFollowBtnAction = () => {
      const action = !followFlag.value;

      isProcessing.value = true;

      API.recordAction({
        action: action ? "follow" : "unfollow",
        object: props.term.taxonomy,
        id: props.term.id,
      }).then(
        () => {
          followFlag.value = action;
          isProcessing.value = false;
        },
        (error) => {
          isProcessing.value = false;
          console.log(error.response.data.message);
        },
      );
    };

    return {
      classes,
      handleClickFollowBtn,
    };
  },
};
</script>
